export default __webpack_public_path__ + "static/media/team2.a0a41a34.jpg";